import axios from 'axios';
import { oneKlicks } from '../../SDK/oneclick';


export const getDoctorsCount = async () => {
    try {
        const tableSchema = '';
        const tableName = 'users';
        const conditions = {
            user_type: 'doctor'
        };
        const responce = await oneKlicks.count(tableSchema, tableName, conditions);

        return responce;

    } catch (error) {
        console.error(error);
        return 0;
    }
};

export const getrecentActivities = async (page = 1, limit = 10) => {
    try {
        const tableSchema = '';
        const tableName = 'activities';
        const conditions = {
        };
        const orderBy = 'id DESC';
        const search = {};
        const pagination = { page: page, limit: limit };
        const margedata = [
            {
                target_table: 'users',
                target_column: 'id',
                target_value: 'user_id',
                target_label: 'users'
            },
            {
                target_table: 'users',
                target_column: 'id',
                target_value: 'localid',
                target_label: 'staff'
            }
        ];
        const responce = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

        if (responce.success && responce.data.length > 0) {
            console.log('responce recent activities :', responce.data);
            return responce;
        } else {
            return [];
        }



    } catch (error) {
        console.error(error);
        return 0;
    }
};


export const getHospitalsCount = async () => {
    try {
        const tableSchema = '';
        const tableName = 'users';
        const conditions = {
            user_type: 'hospitals'
        };
        const responce = await oneKlicks.count(tableSchema, tableName, conditions);

        return responce;

    } catch (error) {
        console.error(error);
        return 0;
    }
};

export const getPatientsCount = async () => {
    try {
        const tableSchema = '';
        const tableName = 'users';
        const conditions = {
            user_type: 'patients'
        };
        const responce = await oneKlicks.count(tableSchema, tableName, conditions);

        return responce;

    } catch (error) {
        console.error(error);
        return 0;
    }
};

export const getStaffCount = async () => {
    try {
        const tableSchema = '';
        const tableName = 'users';
        const conditions = {
            user_type: 'staff'
        };
        const responce = await oneKlicks.count(tableSchema, tableName, conditions);


        return responce;

    } catch (error) {
        console.error(error);
        return 0;
    }
};


export const getNewRegistrationsCount = async () => {
    try {
        const tableSchema = '';
        const tableName = 'users';
        const conditions = {
        };
        const orderBy = 'id DESC';
        const search = {};
        const pagination = {};
        const margedata = [];
        const responce = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

        if (responce.success) {
            console.log('responce new registrations :', responce.data);

            // Calculate date 30 days ago
            const thirtyDaysAgo = new Date();
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

            // Filter registrations from last 30 days
            const recentRegistrations = responce.data.filter(user => {
                const createdAt = new Date(user.created_at);
                return createdAt >= thirtyDaysAgo;
            });

            console.log('Recent registrations (last 30 days):', recentRegistrations.length);
            return recentRegistrations.length;
        } else {
            return 0;
        }

    } catch (error) {
        console.error(error);
        return 0;
    }
};

export const getAppointments = async (page = 1, limit = 10, doctor_id = null, hospital_id = null) => {
    try {
        const tableSchema = '';
        const tableName = 'appointments';
        const conditions = {};
        if (doctor_id) conditions.doctor_id = doctor_id;
        if (hospital_id) conditions.hospital_id = hospital_id;

        const orderBy = 'id DESC';
        const search = {};
        const pagination = { page, limit };
        const margedata = [
            {
                target_table: 'users',
                target_column: 'id',
                target_value: 'doctor_id',
                target_label: 'doctor'
            },
            {
                target_table: 'users',
                target_column: 'id',
                target_value: 'hospital_id',
                target_label: 'hospital'
            },
            {
                target_table: 'users',
                target_column: 'id',
                target_value: 'patient_id',
                target_label: 'patient'
            }
        ];

        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        return response;
    } catch (error) {
        console.error('Error fetching appointments:', error);
        return { success: false, data: [] };
    }
};
